
import axios from 'axios';
const awsBaseURL = 'https://aws.intest.vip'
const AWS = require("aws-sdk");
const Bucket = 'imgqwebucket'
const getAwsStsToken = () => {
  return new Promise((resolve, reject) => {
    axios.post(awsBaseURL + '/api/manager/aws/getStsToken').then(response => {
      if (response.status == 200 && response.data.code == 1) {
        resolve(response.data.data)
      } else {
        reject(response.data.msg)
      }
    })
  })
}
function base64ToFile(base64) {
  let arr = base64.split(",");
  // let mime = arr[0].match(/:(.\*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  let stmp = new Date().getTime()
  let fileName = `${stmp}_${file.name}`
  return new File([u8arr], fileName, { type: 'image/png' });
}
const uploadToS3 = async (file, dir, cb) => {
  return new Promise((resolve, reject) => {
    getAwsStsToken().then(credentials => {
      const s3Client = new AWS.S3({
        region: 'us-east-1',
        credentials: {
          accessKeyId: credentials.AccessKeyId,
          secretAccessKey: credentials.SecretAccessKey,
          sessionToken: credentials.SessionToken
        }
      });
      let stmp = new Date().getTime()
      let file_name = `${stmp}_${file.name}`
      const params = {
        Bucket: Bucket,
        Key: dir + new Date().getTime() + '_' + file_name,
        Body: file,
        ContentType: file.type,
        'Access-Control-Allow-Credentials': '*',
        // 'ACL': 'public-read'
      };
      const upload = s3Client.upload(params).on('httpUploadProgress', function (progress) {
        cb(progress)
      });
      return resolve(upload)
    })
  })
}
export default {
  getAwsStsToken,
  uploadToS3,

  deleteObject(Key) {
    return new Promise((resolve, reject) => {
      getAwsStsToken().then(credentials => {
        const s3Client = new AWS.S3({
          region: 'us-east-1',
          credentials: {
            accessKeyId: credentials.AccessKeyId,
            secretAccessKey: credentials.SecretAccessKey,
            sessionToken: credentials.SessionToken
          }
        });

        s3Client.deleteObject({
          Bucket: Bucket,
          Key
        }, function (err, data) {
          if (data) {
            resolve(data)
          } else {
            reject(err)
          }
        });
      })
    })
  },
  uploadBase64(base64) {
    return new Promise(async (resolve, reject) => {
      const file = await base64ToFile(base64)
      uploadToS3(file, "qwe/").then(uploadInstance => {
        uploadInstance.send((err, result) => {
          if (err) {
            rejecct(err);
          } else {
            resolve(result.Location);
          }
        });
      });
    })

  }
}


